import Layout from "@/views/layout/Layout";
const userCenterRouter = {
  path: "/userCenter",
  name: "userCenter",
  component: Layout,
  redirect: "noRedirect",
  children: [
    // 已发布供应信息路由
    {
      path: "logsupplyList",
      name: "logsupplyList",
      meta: { name: "已发布供应信息" },
      component: () => import("@/views/userCenter/supply/logsupplyList")
    },
    // 发布供应信息路由
    {
      path: "logsupplyAdd",
      name: "logsupplyAdd",
      meta: { name: "发布供应信息" },
      component: () => import("@/views/userCenter/supply/logsupplyAdd")
    },
    // 发布供应信息--自定义分类路由
    {
      path: "logsupplyDiy",
      name: "logsupplyDiy",
      meta: { name: "自定义分类" },
      component: () => import("@/views/userCenter/supply/logsupplyDiy")
    },
    // 发布供应--产品编号设置路由
    {
      path: "logsupplyPrefix",
      name: "logsupplyPrefix",
      meta: { name: "设置产品编号前缀" },
      component: () => import("@/views/userCenter/supply/logsupplyPrefix")
    },
    // 发布供应--模板管理
    {
      path: "logsupplyTemplate",
      name: "logsupplyTemplate",
      meta: { name: "模板管理" },
      component: () => import("@/views/userCenter/supply/logsupplyTemplate")
    },
    // 发布采购信息路由
    {
      path: "logsupplyAddBuy",
      name: "logsupplyAddBuy",
      meta: { name: "发布采购信息" },
      component: () => import("@/views/userCenter/supply/logsupplyAddBuy")
    },
    // 订单管理路由
    {
      path: "logorderManage",
      name: "logorderManage",
      meta: { name: "商品订单" },
      component: () => import("@/views/userCenter/logorderManage")
    },
    // 订单管理路由---卖家
    {
      path: "logorderManageSell",
      name: "logorderManageSell",
      meta: { name: "商品订单" },
      component: () => import("@/views/userCenter/logorderManageSell")
    },
    // 订单管理路由---会员订单
    {
      path: "logorderVip",
      name: "logorderVip",
      meta: { name: "会员订单" },
      component: () => import("@/views/userCenter/vip/logorderVip")
    },
    // 发票管理路由--我的发票
    {
      path: "logmyInvoice",
      name: "logmyInvoice",
      meta: { name: "我的发票" },
      component: () => import("@/views/userCenter/logmyInvoice")
    },
    // 发票管理路由--发票信息
    {
      path: "loginvoiceInfo",
      name: "loginvoiceInfo",
      meta: { name: "发票信息" },
      component: () => import("@/views/userCenter/loginvoiceInfo")
    },
    // T币管理路由
    {
      path: "logtbManage",
      name: "logtbManage",
      meta: { name: "T币管理" },
      component: () => import("@/views/userCenter/logtbManage")
    },
    // T币列表路由
    {
      path: "logtbList",
      name: "logtbList",
      meta: { name: "T币列表" },
      component: () => import("@/views/userCenter/logtbList")
    },
    // 信息管理路由
    {
      path: "loginfoManage",
      name: "loginfoManage",
      meta: { name: "询价报价列表" },
      component: () => import("@/views/userCenter/loginfoManage")
    },
    // 信息管理路由--信息详情
    {
      path: "loginfoManageDetail",
      name: "loginfoManageDetail",
      meta: { name: "信息详情" },
      component: () => import("@/views/userCenter/loginfoManageDetail")
    },
    // 我的收藏路由
    {
      path: "logmyStar",
      name: "logmyStar",
      meta: { name: "我的收藏" },
      component: () => import("@/views/userCenter/logmyStar")
    },
    // 购物车路由
    {
      path: "logcar",
      name: "logcar",
      meta: { name: "购物车" },
      component: () => import("@/views/userCenter/logcar")
    },
    // 会员选择
    {
      path: "logvipSelect",
      name: "logvipSelect",
      meta: { name: "会员服务" },
      component: () => import("@/views/userCenter/vip/logvipSelect")
    },
    // 会员服务路由
    {
      path: "logvipServices",
      name: "logvipServices",
      meta: { name: "会员服务" },
      component: () => import("@/views/userCenter/vip/logvipServices")
    },
    // 企业信息路由
    {
      path: "logcompanyInfo",
      name: "logcompanyInfo",
      meta: { name: "信息管理" },
      component: () => import("@/views/userCenter/logcompanyInfo")
    },
    // 企业信息路由--联系方式
    // {
    //     path: 'logcompanyInfoTel',
    //     name: 'logcompanyInfoTel',
    //     component: () => import('@/views/userCenter/logcompanyInfo'),
    // },
    // 账号信息路由
    {
      path: "loguserInfo",
      name: "loguserInfo",
      meta: { name: "账号信息管理" },
      component: () => import("@/views/userCenter/productManage/loguserInfo")
    },
    // 账号信息--子账号用户权限
    {
      path: "loguserRoot",
      name: "loguserRoot",
      meta: { name: "子账号类型权限" },
      component: () => import("@/views/userCenter/productManage/loguserRoot")
    },
    // 收货地址路由
    {
      path: "logaddress",
      name: "logaddress",
      meta: { name: "收货地址管理" },
      component: () => import("@/views/userCenter/logaddress")
    },
    // 选择企业会员路由
    {
      path: "logvipServicesSelectvip",
      name: "logvipServicesSelectvip",
      meta: { name: "申请会员" },
      component: () => import("@/views/userCenter/vip/logvipServicesSelectvip")
    },
    // 选择设计师会员路由
    {
      path: "logvipServicesSelectdesigner",
      name: "logvipServicesSelectdesigner",
      meta: { name: "申请会员" },
      component: () =>
        import("@/views/userCenter/vip/logvipServicesSelectdesigner")
    },
    // 选择账号路由
    {
      path: "logvipServicesSelectuser",
      name: "logvipServicesSelectuser",
      meta: { name: "申请天珀账号" },
      component: () => import("@/views/userCenter/vip/logvipServicesSelectuser")
    },
    // 组合套餐路由
    {
      path: "logvipServicesTaocan",
      name: "logvipServicesTaocan",
      meta: { name: "组合套餐" },
      component: () => import("@/views/userCenter/vip/logvipServicesTaocan")
    },
    // 会员服务付款路由
    {
      path: "logvipServicesPay",
      name: "logvipServicesPay",
      meta: { name: "等待付款" },
      component: () => import("@/views/userCenter/vip/logvipServicesPay")
    },
    // 设计师管理路由--发布内容
    {
      path: "logdesignerManage",
      name: "logdesignerManage",
      meta: { name: "发布作品" },
      component: () => import("@/views/userCenter/logdesignerManage")
    },
    // 设计师管理路由--我的作品
    {
      path: "logdesignerProduct",
      name: "logdesignerProduct",
      meta: { name: "我的作品" },
      component: () => import("@/views/userCenter/logdesignerManage")
    },
    // 设计师作品详情路由
    {
      path: "logdesignerworks",
      name: "logdesignerworks",
      meta: { name: "作品详情" },
      component: () => import("@/views/userCenter/logdesignerworks")
    },
    // 一物一码列表路由
    {
      path: "logwechatCode",
      name: "logwechatCode",
      meta: { name: "一物一码列表" },
      component: () => import("@/views/userCenter/logwechatCode")
    },
    // 一物一码列表去购买二维码路由
    {
      path: "logwechatCodeBuy",
      name: "logwechatCodeBuy",
      meta: { name: "购买二维码" },
      component: () => import("@/views/userCenter/logwechatCodeBuy")
    },
    // 客户管理路由
    {
      path: "logcustomerManagement",
      name: "logcustomerManagement",
      meta: { name: "客户管理" },
      component: () =>
        import("@/views/userCenter/productManage/logcustomerManagement")
    },
    // 创建生产订单路由
    {
      path: "logaddOrder",
      name: "logaddOrder",
      meta: { name: "生产订单" },
      component: () => import("@/views/userCenter/productManage/logaddOrder")
    },
    // 订单管理路由
    {
      path: "logorderManagement",
      name: "logorderManagement",
      meta: { name: "订单管理" },
      component: () =>
        import("@/views/userCenter/productManage/logorderManagement")
    },
    // 产品管理路由
    {
      path: "logproductManagement",
      name: "logproductManagement",
      meta: { name: "订单管理" },
      component: () =>
        import("@/views/userCenter/productManage/logproductManagement")
    },
    // 订单管理路由--购买的
    // {
    //     path: 'logorderManagementBuy',
    //     name: 'logorderManagementBuy',
    //     meta: { name: '购买订单管理'},
    //     component: () => import('@/views/userCenter/productManage/logorderManagementBuy'),
    // },
    // 订单查看路由
    {
      path: "logviewOrder",
      name: "logviewOrder",
      meta: { name: "生产订单详情" },
      component: () => import("@/views/userCenter/productManage/logviewOrder")
    },
    // 订单审核路由
    {
      path: "logcheckedOrder",
      name: "logcheckedOrder",
      meta: { name: "生产订单审核" },
      component: () =>
        import("@/views/userCenter/productManage/logcheckedOrder")
    },
    // 预设产品列表路由
    {
      path: "logpresetProductList",
      name: "logpresetProductList",
      meta: { name: "预设产品列表" },
      component: () =>
        import("@/views/userCenter/productManage/logpresetProductList")
    },
    // 预设产品路由
    {
      path: "logpresetProduct",
      name: "logpresetProduct",
      meta: { name: "预设产品" },
      component: () =>
        import("@/views/userCenter/productManage/logpresetProduct")
    },
    // 出货单列表路由
    {
      path: "logsalesOrder",
      name: "logsalesOrder",
      meta: { name: "出货单管理" },
      component: () => import("@/views/userCenter/productManage/logsalesOrder")
    },
    // 出货单详情路由
    {
      path: "logsalesDetail",
      name: "logsalesDetail",
      meta: { name: "出货单详情" },
      component: () => import("@/views/userCenter/productManage/logsalesDetail")
    },
    // 生产产品类型列表路由
    {
      path: "logcateList",
      name: "logcateList",
      meta: { name: "生产产品类型列表" },
      component: () => import("@/views/userCenter/productManage/logcateList")
    },
    // 订单跟踪发货列表路由
    {
      path: "logsalesList",
      name: "logsalesList",
      meta: { name: "发货列表" },
      component: () => import("@/views/userCenter/productManage/logsalesList")
    },
    // 订单跟踪已生成出货单的列表路由
    {
      path: "logsalesDoneList",
      name: "logsalesDoneList",
      meta: { name: "出货单管理" },
      component: () =>
        import("@/views/userCenter/productManage/logsalesDoneList")
    },
    // 订单跟踪复制订单（一键翻单）路由
    {
      path: "logrepeatOrder",
      name: "logrepeatOrder",
      meta: { name: "填写订单信息" },
      component: () => import("@/views/userCenter/productManage/logrepeatOrder")
    },
    // 订单跟踪预仓储修改记录路由
    {
      path: "logstoreList",
      name: "logstoreList",
      meta: { name: "库存记录" },
      component: () => import("@/views/userCenter/productManage/logstoreList")
    }
  ]
};
export default userCenterRouter;



// WEBPACK FOOTER //
// ./src/router/modules/userCenter.js